import { useConfigStore } from '@/client/services/state/configStore';
import { usePartnerStore } from '@/client/services/state/partnerStore';

export const useGetBackgroundImageUrl = () => {
  const { partner } = usePartnerStore();
  const { config } = useConfigStore();

  const getBackgroundImageUrl = () => {
    if (partner?.branding?.background_image_urls?.length > 0) {
      const partnerNum = Math.floor(Math.random() * partner.branding.background_image_urls.length);

      return partner.branding.background_image_urls[partnerNum];
    }

    if (config?.theme?.background_image_count > 0) {
      const num = Math.floor(Math.random() * config.theme.background_image_count + 1);

      const bgImageUrl = `${config.publicImageUrl}${config.theme.layout}/login-images/login-${num}.jpg`;

      return bgImageUrl;
    }

    const num = Math.floor(Math.random() * 6 + 1);

    const url = `/public/images/login-images/login-${num}.jpg`;

    return url;
  };

  return { getBackgroundImageUrl };
};
